module.exports = __webpack_public_path__ + "img/cloud-wind.157b5690.svg";